import { render, staticRenderFns } from "./CopySiteDialog.vue?vue&type=template&id=6dba841a&scoped=true"
import script from "./CopySiteDialog.vue?vue&type=script&lang=js"
export * from "./CopySiteDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dba841a",
  null
  
)

export default component.exports